import Axios, { AxiosResponse } from 'axios';
import GlobalConfig from "@/GlobalConfig";
import ActualizacionDatosModel from '@/models/ActualizacionDatos/ActualizacionDatosModel';
import EstadoDeCuentaModelModel from '@/models/TuEstadoCuenta/TuEstadoCuentaModel';
import EstadoDeCuentaModel from '@/models/TuEstadoCuenta/TuEstadoCuentaModel';
import MiInversionModel from '@/models/MiInversion/MiInversionModel';
import TipoEnvioEstadoCuentaModel from '@/models/TipoEnvioEstadoCuenta/TipoEnvioEstadoCuentaModel';
import ServicioNotificacionBalanceModel, { UserBalanceModel } from '@/models/ServicioNotificacionBalance/ServicioNotificacionBalanceModel';
import ConsultaReclamacionesModel from '@/models/ConsultaReclamaciones/ConsultaReclamacionesModel';
import SolicitudReclamacionesModel from '@/models/SolicitudReclamaciones/SolicitudReclamacionesModel';
import SolicitudNotificacionBalanceModel from '@/models/SolicitudNotificacionBalance/SolicitudNotificacionBalanceModel';
import CertificadoBeneficiosModel from '@/models/CertificadoBeneficios/CertificadoBeneficiosModel';
import TourVirtualUmbracoResponse from '@/models/TourVirtual/TourVirtualUmbracoResponse';
 

export default class UmbracoApiService {

	public apiUrl: string;

	public constructor() {
		this.apiUrl = GlobalConfig.UMBRACO_API_URL;
	}
	public async get(controller: string): Promise<AxiosResponse<any>> {
		let headers = {
			'Content-Type': 'application/json'
		};
		return Axios.get(this.apiUrl + controller, {
			headers: headers
		})
	}

	public async getSolicitud(): Promise<UserBalanceModel> {
		let controller = "Afiliado/SolvexSolicitud"

		let result = await Axios.get(`${GlobalConfig.API_URL}${controller}`)
		return result.data;
	}



	public async getActualizacionDatos(): Promise<ActualizacionDatosModel> {
		let headers = {
			'Content-Type': 'application/json'
		};

		let controller = "Benefit/_umbracoPersonalDataUpdate/0"

		let result = await Axios.get(`${this.apiUrl}${controller}`, {
			headers: headers
		})
		return result.data;
	}

	public async getEstadoDeCuenta(): Promise<EstadoDeCuentaModel> {
		let headers = {
			'Content-Type': 'application/json'
		};

		let controller = "Benefit/_umbracoAccountStatus/0"

		let result = await Axios.get(`${this.apiUrl}${controller}`, {
			headers: headers
		})
		return result.data;
	}

	public async getMiInversion(): Promise<MiInversionModel> {
		let headers = {
			'Content-Type': 'application/json'
		};

		let controller = "Benefit/_umbracoMyInverstement/0"

		let result = await Axios.get(`${this.apiUrl}${controller}`, {
			headers: headers
		})
		return result.data;
	}

	public async getTipoEnvioEstadoCuenta(): Promise<TipoEnvioEstadoCuentaModel> {
		let headers = {
			'Content-Type': 'application/json'
		};

		let controller = "Benefit/_umbracoShippingType/0"

		let result = await Axios.get(`${this.apiUrl}${controller}`, {
			headers: headers
		})
		return result.data;
	}

	public async getServicioNotificacionAportes(): Promise<ServicioNotificacionBalanceModel> {
		let headers = {
			'Content-Type': 'application/json'
		};

		let controller = "Benefit/_umbracoRequestForNotificationOfContributions/0"

		let result = await Axios.get(`${this.apiUrl}${controller}`, {
			headers: headers
		})
		return result.data;
	}

	public async getConsultaReclamaciones(): Promise<ConsultaReclamacionesModel> {
		let headers = {
			'Content-Type': 'application/json'
		};

		let controller = "Benefit/_umbracoClaimsConsultation/0"

		let result = await Axios.get(`${this.apiUrl}${controller}`, {
			headers: headers
		})
		return result.data;
	}

	public async getSolicitudReclamaciones(): Promise<SolicitudReclamacionesModel> {
		let headers = {
			'Content-Type': 'application/json'
		};

		let controller = "Benefit/_umbracoClaims/0"

		let result = await Axios.get(`${this.apiUrl}${controller}`, {
			headers: headers
		})
		return result.data;
	}

	public async getSolicitudNotificacionBalance(): Promise<SolicitudNotificacionBalanceModel> {
		let headers = {
			'Content-Type': 'application/json'
		};

		let controller = "Benefit/_umbracoBalanceNotificationRequest/0"

		let result = await Axios.get(`${this.apiUrl}${controller}`, {
			headers: headers
		})
		return result.data;
	}

	public async getCertificadoBeneficios(): Promise<CertificadoBeneficiosModel> {
		let headers = {
			'Content-Type': 'application/json'
		};

		let controller = "Benefit/_umbracoCertification/0"

		let result = await Axios.get(`${this.apiUrl}${controller}`, {
			headers: headers
		})
		return result.data;
	}

	public async getTourVirtualUrl(): Promise<TourVirtualUmbracoResponse> {
		let headers = {
			'Content-Type': 'application/json'
		};

		let controller = "Benefit/_umbracoVirtualTour"

		let result = await Axios.get(`${this.apiUrl}${controller}`, {
			headers: headers
		})
		return result.data;
	}
	

}